<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
  <div class="flex flex-col w-full max-w-xl aspect-square gap-4 p-4 bg-white rounded shadow-lg relative mx-4 animate-in fade-in zoom-in duration-200">
    <div class="flex flex-row justify-between items-center border-b pb-3 mb-2 flex-none">
      <h3 class="font-bold text-xl text-blueGray-800">Community Location</h3>
      <btn-icon icon="fa fa-close" (click)="onClose()" class="text-primary-300 hover:text-primary-300"></btn-icon>
    </div>
    <div class="w-full flex-1 min-h-0 rounded overflow-hidden">
      <app-view-location [location]="location" height="100%"></app-view-location>
    </div>
  </div>
</div>
